// Mock data for TOR1 Import Services Website

export const mockData = {
  hero: {
    title: "Moving Back to the UK from Abroad?",
    subtitle: "Transfer of Residence (TOR1) Services",
    description: "Relocating back to the UK? Our expert TOR1 Transfer of Residence services help UK nationals bring their personal belongings and furniture from overseas without paying customs duty.",
    ctaPrimary: "Get Started",
    ctaSecondary: "Learn More",
    image: "https://images.unsplash.com/photo-1678182451047-196f22a4143e?crop=entropy&cs=srgb&fm=jpg"
  },

  services: [
    {
      id: 1,
      title: "TOR1 Application Processing",
      description: "Expert handling of your Transfer of Residence applications, ensuring all UK customs requirements are met for duty-free relocation from anywhere in the world.",
      icon: "FileText"
    },
    {
      id: 2,
      title: "Customs Documentation",
      description: "Complete preparation of inventory lists, proof of residence documents, and all customs paperwork for your personal belongings from overseas.",
      icon: "ClipboardCheck"
    },
    {
      id: 3,
      title: "Eligibility Assessment",
      description: "Professional verification of your residency status and eligibility for Transfer of Residence relief on personal items, wherever you're returning from.",
      icon: "Shield"
    }
  ],

  howItWorks: [
    {
      step: 1,
      title: "Initial Consultation",
      description: "Share details about your overseas residence history and the personal belongings you're bringing back to the UK."
    },
    {
      step: 2,
      title: "Eligibility Verification",
      description: "We confirm your UK national status, overseas residence period, and verify eligibility for Transfer of Residence relief."
    },
    {
      step: 3,
      title: "Documentation & Application",
      description: "We prepare your inventory list, gather proof of residence documents, and submit your TOR1 application to UK customs."
    },
    {
      step: 4,
      title: "Customs Clearance",
      description: "Receive approval and bring your furniture and personal items back to the UK duty-free and VAT-free."
    }
  ],

  benefits: [
    {
      id: 1,
      title: "No Customs Duty or VAT",
      description: "Bring your personal belongings, furniture, and household items back to the UK from anywhere in the world without paying customs duty or VAT.",
      icon: "TrendingDown"
    },
    {
      id: 2,
      title: "UK Government Approved",
      description: "Fully compliant Transfer of Residence relief program recognized and authorized by HMRC and UK Border Force.",
      icon: "BadgeCheck"
    },
    {
      id: 3,
      title: "Stress-Free Relocation",
      description: "We handle all the paperwork and customs procedures so you can focus on settling back into the UK.",
      icon: "Zap"
    },
    {
      id: 4,
      title: "Expert Customs Support",
      description: "Specialist knowledge of Transfer of Residence regulations for UK nationals returning from any country worldwide.",
      icon: "Users"
    },
    {
      id: 5,
      title: "Full Documentation Assistance",
      description: "We prepare your inventory lists, residence proofs, and all customs declarations to ensure smooth clearance.",
      icon: "CheckCircle"
    },
    {
      id: 6,
      title: "Save Thousands",
      description: "Avoid paying duty and VAT on your personal possessions, potentially saving thousands of pounds on your move.",
      icon: "TrendingUp"
    }
  ],

  testimonials: [
    {
      id: 1,
      name: "David Thompson",
      company: "Returned from Spain",
      role: "UK National",
      content: "After 8 years in Barcelona, moving back was daunting. The TOR1 team made customs clearance effortless. Saved over £4,000 in duty and VAT on our furniture!",
      rating: 5
    },
    {
      id: 2,
      name: "Sarah Patel",
      company: "Returned from Dubai",
      role: "UK National",
      content: "Relocated from UAE after 5 years. The team handled all documentation professionally. Our household goods cleared customs without any issues. Highly recommend!",
      rating: 5
    },
    {
      id: 3,
      name: "Michael Davies",
      company: "Returned from Australia",
      role: "UK National",
      content: "Exceptional support throughout our relocation from Sydney. Their knowledge of Transfer of Residence regulations saved us thousands. Worth every penny!",
      rating: 5
    }
  ],

  faqs: [
    {
      id: 1,
      question: "What is Transfer of Residence (TOR1)?",
      answer: "Transfer of Residence is a UK customs relief that allows UK nationals who have been living abroad to bring their personal belongings and furniture back to the UK without paying customs duty or VAT. It's designed for people permanently relocating back to the UK after living overseas in any country."
    },
    {
      id: 2,
      question: "Who is eligible for TOR1 relief?",
      answer: "You must be a UK national (or have right of abode in the UK) who has been a resident outside the UK for at least 12 consecutive months. The goods must be for your personal use, owned and used by you abroad for at least 6 months, and you must intend to establish permanent residence in the UK. This applies regardless of which country you're returning from."
    },
    {
      id: 3,
      question: "What items can I bring back duty-free?",
      answer: "Eligible items include furniture, household appliances, personal effects, clothing, books, and other personal belongings that you owned and used while living abroad. Items must be for personal use, not for commercial purposes. Some restrictions apply to new or commercial goods."
    },
    {
      id: 4,
      question: "What documents do I need?",
      answer: "You'll need proof of UK nationality (passport), evidence of overseas residence (rental contracts, utility bills, tax documents covering at least 12 months), a detailed inventory list of items, and proof that you owned and used the goods for at least 6 months abroad."
    },
    {
      id: 5,
      question: "How much can I save with TOR1?",
      answer: "Savings depend on the value and type of goods. For furniture and household items, you could save between 2-5% customs duty plus 20% VAT. For a typical household relocation worth £20,000, you could save £4,000-£5,000 in duty and VAT."
    },
    {
      id: 6,
      question: "Which countries does this apply to?",
      answer: "Transfer of Residence relief applies to UK nationals returning from any country worldwide - including EU countries, USA, Australia, Middle East, Asia, and anywhere else you may have been living. The key requirement is 12 months overseas residence, regardless of location."
    }
  ],

  contactInfo: {
    email: "info@tor1services.co.uk",
    phone: "0034699913354"
  },

  stats: [
    { label: "UK Nationals Helped", value: "1,200+" },
    { label: "Duty & VAT Saved", value: "£4.8M+" },
    { label: "Client Satisfaction", value: "99%" },
    { label: "Average Processing Time", value: "7 Days" }
  ]
};
